module.exports = __webpack_public_path__ + "static/media/feature3.d18cea18.png";